import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';

import styles from './styles.js';

class IndentedCardContent extends React.Component {
  render() {
    const {
      classes,
      body,
      helpText,
      hasAction,
      noIndent,
    } = this.props;

    return (
      <CardContent
        className="CardContent"
        classes={{
          root: !hasAction && !noIndent
            ? classes.cardContent
            : noIndent
              ? `${classes.cardContentNoIndent} ${classes.cardContent}`
              : classes.cardContentAction,
        }}
      >
        {body}
        {helpText ? <Typography className={classes.helpText}> {helpText} </Typography> : ""}
      </CardContent>
    );
  }
}

IndentedCardContent.propTypes = {
  classes: PropTypes.object.isRequired,
  body: PropTypes.object,
  helpText: PropTypes.string,
  hasAction: PropTypes.bool,
  noIndent: PropTypes.bool,
}

IndentedCardContent.defaultProps = {
  helpText: "",
  hasAction: false,
  noIndent: false,
};

export default withStyles(styles)(IndentedCardContent);